<template>
  <div>
    <router-view v-slot="{ Component }">
      <!-- <transition> -->
      <keep-alive :include="state.include">
        <component :is="Component">
        </component>
      </keep-alive>

    </router-view>
  </div>
</template>

<script>
  import {
    reactive,
  } from 'vue'
  import {
    useStore
  } from 'vuex'
  // import {
  //   getChannelId
  // } from "@/api/index.js"
  // import utils from "@/utils/utils.js"
  //app.vue文件
  export default {
    name: 'App',

    setup() {
      const store = useStore()
      const state = reactive({

        include: [

        ]
      })
      store.dispatch('init')

      // const getChannelIdData = () => {
      //   let params = utils.queryURLParams(window.location.href);
      //   let hostname = new URL(window.location.href).hostname;
      //   let channelUid = params.channelUid;
      //   if (!channelUid) {
      //     getChannelId({
      //       siteUrl: hostname
      //     }).then(res => {
      //       if (res) {
      //         store.commit("SET_CHANNEL_ID", res);
      //       }
      //     })
      //   }
      // }
      // getChannelIdData()
      return {
        state,
      }
    }
  }
</script>

<style lang="less">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    // -webkit-font-smoothing: antialiased;
    // -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // color: #2c3e50;
    height: 100%;
  }
</style>